import React from 'react';
import { push } from 'redux-first-history';
import { Outlet, useNavigate, useParams } from 'react-router';

import { useDispatch, useSelector } from 'hooks';
import { toUrlSlug } from 'utils/stepUrlUtils';
import { RedirectPathConfig } from 'modules/auth/utils';
import { getSearch } from 'modules/router/selectors';
import Inactivity from 'components/SelfServices/Inactivity';
import { INACTIVITY_SELF_SERVICE_FLOWS } from 'modules/auth/constants';
import { getSelectedSelfServiceId } from 'modules/auth/selectors';
import { useGetSelfServiceByIdQuery } from 'modules/selfServices/service';

import useReopenSteps from './steps';
import type { ReopenOutletContext } from './ReopenStepContent';

const ReopenKiosk = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { step: stepSlug } = useParams<{ step: string }>();
  const steps = useReopenSteps();

  const search = useSelector(getSearch);
  const selfServiceId = useSelector(getSelectedSelfServiceId);
  const { data: selfService } = useGetSelfServiceByIdQuery({ id: selfServiceId }, { refetchOnMountOrArgChange: true });

  // Redirect to first step if no step in URL
  React.useEffect(() => {
    if (steps.length > 0 && !stepSlug) {
      navigate(`${toUrlSlug(steps[0].key)}${search}`, { replace: true });
    }
  }, [steps, stepSlug, navigate, search]);

  const handleBoundary = React.useCallback((end?: boolean) => {
    if (end) {
      const redirectUrl = RedirectPathConfig[selfService.type];
      dispatch(push(`${redirectUrl}${search}`));
    } else {
      navigate(-1);
    }
  }, [dispatch, navigate, search, selfService]);

  const outletContext: ReopenOutletContext = {
    steps,
    onBoundary: handleBoundary,
  };

  return (
    <>
      <Outlet context={outletContext} />
      <Inactivity seconds={INACTIVITY_SELF_SERVICE_FLOWS} />
    </>
  );
};

export default ReopenKiosk;
